module.exports = __webpack_public_path__ + "img/shijiazhuangjidi.b1327e3f.png";